import JanelaIndicator from "./JanelaIndicator";

function formatarHora(isoString) {
  if (!isoString) return "";
  const data = new Date(isoString);
  const agora = new Date();
  const mesmoDia =
    data.getDate() === agora.getDate() &&
    data.getMonth() === agora.getMonth() &&
    data.getFullYear() === agora.getFullYear();

  if (mesmoDia) {
    return data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  }
  return data.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}

function Avatar({ nome }) {
  const inicial = (nome || "?")[0].toUpperCase();
  const paletas = [
    "bg-brand-800 text-brand-200",
    "bg-blue-800 text-blue-200",
    "bg-teal-800 text-teal-200",
    "bg-rose-800 text-rose-200",
    "bg-amber-800 text-amber-200",
  ];
  const indice = inicial.charCodeAt(0) % paletas.length;
  return (
    <div
      className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 select-none ${paletas[indice]}`}
      aria-hidden="true"
    >
      {inicial}
    </div>
  );
}

// Extrai texto seguro de um conteudo heterogêneo (mesma lógica de
// MessageBubble.extrairTexto, duplicada aqui pra evitar dependência
// cruzada). Sempre devolve string — nunca objeto.
function extrairSnippet(conteudo) {
  if (!conteudo) return "";
  if (typeof conteudo === "string") return conteudo;
  if (typeof conteudo.body === "string") return conteudo.body;
  if (typeof conteudo.text === "string") return conteudo.text;
  if (conteudo.text && typeof conteudo.text.body === "string") return conteudo.text.body;
  if (typeof conteudo.caption === "string") return conteudo.caption;
  if (conteudo.button && typeof conteudo.button.text === "string") return `↩ ${conteudo.button.text}`;
  if (conteudo.raw?.button?.text) return `↩ ${conteudo.raw.button.text}`;
  return "";
}

function rotuloTipo(tipo) {
  switch (tipo) {
    case "image":       return "📷 Imagem";
    case "video":       return "🎥 Vídeo";
    case "audio":       return "🎤 Áudio";
    case "document":    return "📄 Documento";
    case "sticker":     return "🌟 Sticker";
    case "location":    return "📍 Localização";
    case "contacts":    return "👤 Contato";
    case "interactive": return "🔘 Interativo";
    case "template":    return "📋 Template";
    default:            return "";
  }
}

export default function ConversaItem({ conversa, selected, onClick }) {
  const nome = conversa.cliente_nome || conversa.wa_id || "Desconhecido";
  const telefone = conversa.wa_id || "";

  // Backend REST retorna campos FLAT (ultima_mensagem_*); payload do socket
  // envia objeto aninhado (ultima_mensagem.snippet). Aceita ambos.
  const conteudo      = conversa.ultima_mensagem_conteudo ?? conversa.ultima_mensagem?.conteudo ?? null;
  const tipo          = conversa.ultima_mensagem_tipo     ?? conversa.ultima_mensagem?.tipo     ?? "";
  const dataMsg       = conversa.ultima_mensagem_data     ?? conversa.ultima_mensagem?.data     ?? null;
  const snippetSocket = conversa.ultima_mensagem?.snippet;
  const snippet       = snippetSocket || extrairSnippet(conteudo) || rotuloTipo(tipo);
  const hora          = formatarHora(dataMsg || conversa.ultimo_inbound_em);
  const unread        = conversa.unread_count || 0;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      aria-label={`Conversa com ${nome}${unread > 0 ? `, ${unread} mensagem${unread > 1 ? "s" : ""} não lida${unread > 1 ? "s" : ""}` : ""}`}
      className={`w-full text-left flex items-start gap-3 px-3 py-3 border-b border-white/[0.06] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500 ${
        selected ? "bg-surface-2" : "hover:bg-surface-1/80"
      }`}
    >
      <Avatar nome={nome} />

      <div className="flex-1 min-w-0">
        {/* Linha superior: nome + hora */}
        <div className="flex items-center justify-between gap-2 mb-0.5">
          <span className="text-sm font-semibold text-ink-1 truncate leading-tight">
            {nome}
          </span>
          <span className="text-xs text-ink-4 flex-shrink-0 tabular-nums">{hora}</span>
        </div>

        {/* Linha do telefone (wa_id) quando diferente do nome */}
        {telefone && telefone !== nome && (
          <p className="text-xs text-ink-5 truncate mb-0.5">{telefone}</p>
        )}

        {/* Linha snippet + badge unread */}
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs text-ink-3 truncate">
            {snippet || <span className="italic text-ink-5">Sem mensagens</span>}
          </p>
          {unread > 0 && (
            <span
              className="flex-shrink-0 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-600 text-white text-[10px] font-bold flex items-center justify-center"
              aria-label={`${unread} não lida${unread > 1 ? "s" : ""}`}
            >
              {unread > 99 ? "99+" : unread}
            </span>
          )}
        </div>

        {/* Indicador de janela compacto */}
        <div className="mt-1.5">
          <JanelaIndicator janelaExpiraEm={conversa.janela_expira_em} />
        </div>
      </div>
    </button>
  );
}
